export enum UserRole {
  CONTRACTED_OPERATOR = 'contracted_operator',
  EXTERNAL_OPERATOR = 'external_operator',
  ADMIN = 'admin'
}
